import styled from "styled-components";

export const StepsPaymentContainer = styled.div`
  display: flex;
  gap: 15px;
  align-items: flex-start;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    p {
      font-weight: 600;
      font-size: 12px;
      margin: 0;
    }
  }

  .step-icon {
    width: 40px;
    height: 40px;
  }

  .completed-label {
    color: rgba(0, 0, 0, 0.88);
  }

  .incompleted-label {
    color: rgba(0, 0, 0, 0.55);
  }

  .line {
    width: 100%;
    border-top: 1px solid #e0e0e0;
    height: 0;
    margin-top: 20px;
  }
`;
